const LINK_TYPES = {
  EMAIL: 'email',
  PHONE: 'phone',
  URL: 'url',
};

export const getLinkProps = link => {
  switch (link.linkType) {
    case LINK_TYPES.EMAIL:
      return { href: `mailto:${link.linkValue}`, target: '_self' };
    case LINK_TYPES.PHONE:
      return { href: `tel:${link.linkValue}`, target: '_blank' };
    case LINK_TYPES.URL:
    default:
      return { href: link.linkValue, target: '_blank' };
  }
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/HealthboardHome/components/CustomButtons/utils/getLinkProps.js